import axios from "axios"

import type { Participant } from "@/types/api-types"

import { API_ROOT_URL } from "."

export const fetchParticipant = async (): Promise<Participant> => {
  const { data } = await axios.get<Participant>(`${API_ROOT_URL}/protected/participant`)
  return data
}
